import { Zap, Activity, HardDrive, ShieldCheck, ArrowRight, Info } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { ProHeroCard } from './ProHeroCard';
import { useDiagnosticContext } from '../context/DiagnosticContext';
import styles from './DiagnosticsGrid.module.css';

const FreeCheckCard = () => {
  const navigate = useNavigate();
  const { resetDiagnostic } = useDiagnosticContext();
  
  return (
    <div className={styles.freeCard}>
      <div className={styles.freeHeader}>
        <div className={styles.freeIconBox}>
          <Activity size={24} />
        </div>
        <div className={styles.freeTitleArea}>
          <h3>Free Health Preview</h3>
          <p>Quick lightweight scan for basic system health detection.</p>
        </div>
      </div>

      <div className={styles.freeFeatures}>
        <div className={styles.freeFeature}>
          <Activity size={14} />
          <span>RAM Usage & Memory Leaks</span>
        </div>
        <div className={styles.freeFeature}>
          <HardDrive size={14} />
          <span>Disk Space & Drive Health</span>
        </div>
        <div className={styles.freeFeature}>
          <Zap size={14} />
          <span>Uptime & Basic Performance</span>
        </div>
      </div>

      <div className={styles.freeFooter}>
        <button className={styles.freeBtn} onClick={() => { resetDiagnostic(); navigate('/diagnostic'); }}>
          Start Free Preview <ArrowRight size={16} />
        </button>
        <span className={styles.freeTag}>Included Free</span>
      </div>
    </div>
  );
};

interface DiagnosticsGridProps {
  onCopySuccess: () => void;
}

export const DiagnosticsGrid = ({ onCopySuccess }: DiagnosticsGridProps) => {
  return (
    <section className={styles.section} id="free-checks">
      <div className="wrap">
        <div className={styles.header}>
          <div className="section-label">Diagnostic Suite</div>
          <h2>One Scanner. Two Analysis Tiers.</h2>
          <p className={styles.headerDesc}>
            Download our single diagnostic tool to collect your PC data, then choose your report tier.
          </p>
        </div>

        <div className={styles.optionsLayout}>
          <div className={styles.optionCol}>
            <FreeCheckCard />
          </div>
          <div className={styles.optionColMain}>
            <ProHeroCard />
          </div>
        </div>

        <div className={styles.trustFooter}>
          <div className={styles.trustItem}>
            <ShieldCheck size={18} />
            <span>100% Safe • No Software Installed</span>
          </div>
          <div className={styles.trustItem}>
            <Info size={18} />
            <span>GDPR Compliant • Data Encrypted</span>
          </div>
        </div>
      </div>
    </section>
  );
};
